import { render, staticRenderFns } from "./channelAttributeBLock.vue?vue&type=template&id=24648659&"
import script from "./channelAttributeBLock.vue?vue&type=script&lang=ts&"
export * from "./channelAttributeBLock.vue?vue&type=script&lang=ts&"
import style0 from "./channelAttributeBLock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports